module.exports = __webpack_public_path__ + "assets/videos/intro/intro-3d-new/0022.jpg?v=e6be64b6";